import {
  caseFilterOptions,
  automationModules,
  leadFilterOptions,
  contactFilterOptions,
  fileFilterOptions,
  eventFilterOptions,
  taskFilterOptions,
  billingFilterOptions,
  pastDueFilterOptions,
  leadStageFilter,
  caseStageFilter,
  caseClosedFilterOptions,
} from 'constants/automation';

export const getFilterOptions = (module, code) => {
  switch (module) {
    case automationModules.CASES:
      const Casefilters = [...caseFilterOptions];
      if (code === 'TRIG_CASE_STAGE_CHANGE') Casefilters.push(caseStageFilter);
      if (code === 'TRIG_CASE_STATUS_CHANGE') return [...Casefilters, ...caseClosedFilterOptions];
      return Casefilters;
    case automationModules.LEADS:
      const Leadfilters = [...leadFilterOptions];
      if (code === 'TRIG_LEAD_STAGE_CHANGE') Leadfilters.push(leadStageFilter);
      return Leadfilters;
    case automationModules.CONTACTS:
      return contactFilterOptions;
    case automationModules.FILES:
      return fileFilterOptions;
    case automationModules.EVENTS:
      return eventFilterOptions;
    case automationModules.TASKS:
      return taskFilterOptions;
    case automationModules.BILLING:
      if (code === 'TRIG_INVOICE_PASTDUE' || code === 'TRIG_PAYMENT_REQUEST_PASTDUE') return pastDueFilterOptions;
      return billingFilterOptions;
    default:
      return [];
  }
};
